import { SupabaseEdgeHttpClient } from '@/shared/infra/http'
import type { Zone } from '@/shared/domain'
import type { GetZonesByIds } from '@/shared/domain/use-cases'

export class EdgeGetZonesByIdsRepository {
  constructor(private readonly http: SupabaseEdgeHttpClient) {}

  execute: GetZonesByIds = async (params) => {
    if (params.ids.length === 0) return []
    const res = await this.http.post<{ ids: string[] }, { zones: Zone[] }>({
      url: '/locations/zones/batch',
      body: { ids: params.ids },
    })
    return res.zones
  }
}
